import Scrollbar from 'src/components/scrollbar';

import { useConversationEditor } from '@modules/conversation/hooks/useConversationEditor';
import EmptyContent from 'src/components/empty-content';
import { SkeletonConversationItem } from 'src/components/skeleton';
import { useLocales } from 'src/locales';
import { useChatConversationContext } from 'src/sections/@dashboard/chat/ChatConversation/useChatConversationContext';
import { PinnedMessageItem } from './PinnedMessageItem';
import { usePinnedMessages } from './usePinnedMessages';

const ITEM_HEIGHT = 162;

export const PinnedMessagesList = ({ channelId }: { channelId: string }) => {
  const { editorConfig } = useChatConversationContext();
  const { translate } = useLocales();

  // TODO: pass down just the editor extensions to use with @tiptap/core generateJSON
  const { editor, editorLoaded } = useConversationEditor({
    conversationId: channelId,
    editorConfig,
  });

  const { isFetching, messagesData, unpinMessage } = usePinnedMessages({
    channelId,
  });
  if (isFetching) {
    return (
      <>
        <SkeletonConversationItem />
        <SkeletonConversationItem />
      </>
    );
  }

  if (!messagesData?.length) {
    return (
      <EmptyContent
        sx={{ height: 300 }}
        title={translate('communicate.chat.no_pinned_messages')}
        description={translate(
          'communicate.chat.no_pinned_messages_description',
        )}
        img="/assets/illustrations/illustration_empty_content.svg"
      />
    );
  }

  if (!editorLoaded) {
    return null;
  }

  return (
    <Scrollbar sx={{ maxHeight: ITEM_HEIGHT * 2, height: 'auto' }}>
      {messagesData.map((message) => (
        <PinnedMessageItem
          key={message._id}
          message={message}
          editor={editor}
          unpinMessage={unpinMessage}
        />
      ))}
    </Scrollbar>
  );
};
